import React from 'react';

const PostFormContext = React.createContext({
  asDialog: false,
  editing: false,

  disableScheduling: true,
  disableChannelSelect: false,
  disableDraft: false,
  videoUploader: {},

  onlyActivity: false,
  challengeId: null,

  onClose: () => {},

  view: 'base',
  setView: () => {},
});

export default PostFormContext;
